import { render, staticRenderFns } from "./ConventionCompactInfoAnnotations.vue?vue&type=template&id=e01ef5ca&scoped=true"
import script from "./ConventionCompactInfoAnnotations.vue?vue&type=script&lang=js"
export * from "./ConventionCompactInfoAnnotations.vue?vue&type=script&lang=js"
import style0 from "./ConventionCompactInfoAnnotations.vue?vue&type=style&index=0&id=e01ef5ca&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01ef5ca",
  null
  
)

export default component.exports